/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function t(t){return!!t.update}export{t as isUpdatableTexture};
